// extracted by css-extract-rspack-plugin
export default {"Flash":"BlobLowerBanners-module__Flash__oVItofE"};